import React from 'react';
import PropTypes from 'prop-types';
import EmptyStateImage from 'assets/no_products_found.svg';

const EmptyTableState = ({
  title,
  message,
  overlayIcon,
  button,
  dataTestId = 'empty-table-state',
  containerClassName = 'w-full h-full pt-52px pb-66px flex flex-col justify-center items-center',
  messageClassName = 'text-sm mb-4'
}) => (
  <div data-testid={dataTestId} className={containerClassName}>
    <img width={234} src={overlayIcon ?? EmptyStateImage} alt="empty-state" />
    <p
      className={`text-sm font-semibold mb-2 ${
        overlayIcon === '/static/media/noDocumentFound.e8c780e2.svg'
          ? 'mt-10'
          : null
      }`}
    >
      {title}
    </p>
    {message && (
      <p data-testid="empty-table-state-message" className={messageClassName}>
        {message}
      </p>
    )}
    {button}
  </div>
);

EmptyTableState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  overlayIcon: PropTypes.element,
  button: PropTypes.element,
  dataTestId: PropTypes.string,
  containerClassName: PropTypes.string,
  messageClassName: PropTypes.string
};

EmptyTableState.defaultProps = {
  title: 'No Results Found',
  message: '',
  overlayIcon: null,
  button: null,
  dataTestId: 'empty-table-state',
  containerClassName:
    'w-full h-full pt-52px pb-66px flex flex-col justify-center items-center',
  messageClassName: 'text-sm mb-4'
};

export default EmptyTableState;
